import {
  OfferItem,
} from "../../../../../subcontactor-views/offer-view-subcontractor/components/offer-view-content-subcontractor";
import styled from "styled-components";

export type StatementForTheOffer = {
  numberOfPallets: number;
  totalArea: number;
  numberOfAdditionalServices: number | null;
};

export const statementForTheOfferHandler = (object: OfferItem):StatementForTheOffer => {
  let _numberOfPalletsBasic: number[] = [];
  let _totalAreaBasic: number[] = [];
  let _numberOfAdditionalServices: number[] = [];
  let result: StatementForTheOffer;
  object.data.map((item) => {
    if (
      item.Usluga === 3 ||
      item.Usluga === 4 ||
      item.Usluga === 5 ||
      item.Usluga === 6 ||
      item.Usluga === 7 ||
      item.Usluga === 8
    ) {
      _numberOfAdditionalServices.push(item.ilosc);
    } else {
      _numberOfPalletsBasic.push(item.ilosc);
      _totalAreaBasic.push(item.rozmiarm2);
    }
  });
  result = {
    numberOfPallets: _numberOfPalletsBasic ? _numberOfPalletsBasic[0] : 0,
    totalArea: _totalAreaBasic ? _totalAreaBasic[0] : 0,
    numberOfAdditionalServices: _numberOfAdditionalServices
      ? _numberOfAdditionalServices[0]
      : null,
  };
  return result;
};

interface StatementForTheOfferProps {
  statementsum:StatementForTheOffer;
}
export const StatementForTheOfferComponent = ({
  statementsum,
}: StatementForTheOfferProps) => {
  const statementForTheOffer=statementsum;
  return (
    <>
      <Quantity>Ilość: {statementForTheOffer.numberOfPallets} szt.</Quantity>
      <TotalArea>
        Łącznie: {statementForTheOffer.totalArea.toFixed(2)} m<sup>2</sup>
      </TotalArea>
      <TotalAdditionalServices>
        Liczba usług dodatkowych: {" "}{statementForTheOffer.numberOfAdditionalServices?statementForTheOffer.numberOfAdditionalServices:"-"}

      </TotalAdditionalServices>
    </>
  );
};
const Quantity = styled.div`
  padding-top: 8px;
`;
const TotalArea = styled.div`
  margin-top: -4px;
`;
const TotalAdditionalServices = styled.div``;

